import { render, staticRenderFns } from "./dateDimensionForm.vue?vue&type=template&id=2c5bf940&scoped=true"
import script from "./dateDimensionForm.vue?vue&type=script&lang=js"
export * from "./dateDimensionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5bf940",
  null
  
)

export default component.exports